import { WindowSharp } from "@mui/icons-material";
import { StorageEnum } from "../enums/storage.enum";

export const refreshSession = (): void => {
    const expiryDuration = 30; //minutes
    const tokenExpiryTime = Date.now() + expiryDuration * 1000 * 60; 
    localStorage.setItem(StorageEnum.TokenExpiration, tokenExpiryTime.toString());
};

export const checkSession = (): void => {
    const expiration = window.localStorage.getItem(StorageEnum.TokenExpiration);
    if (!expiration || Date.now() > parseInt(expiration, 10)) {
      window.localStorage.clear();
      window.location.href = '/auth/login';
    }
}